// extracted by mini-css-extract-plugin
module.exports = {"ico24":"EventsNavigationComponent_ico24__sJub9"};